import { AvatarMenu as UiAvatarMenu, useT } from "@iga/ui";
import { useLocaleSetting, type PortalLocale } from "../lib/locale";

/** Portal top-bar avatar menu (shared `AvatarMenu` in the AppShell `userMenu` slot): profile, theme, language, sign out. */
export function AvatarMenu({ user, onLogout }: { user: { displayName: string; email?: string | null }; onLogout: () => void }) {
  const t = useT();
  const { locale, setLocale } = useLocaleSetting();
  return <UiAvatarMenu user={user} onLogout={onLogout} profileTo="/profile" profileLabel={t("p.nav.profile")} locale={locale} locales={[{ value: "en", label: "English" }, { value: "da", label: "Dansk" }]} onLocaleChange={(l) => setLocale(l as PortalLocale)} />;
}
